module.exports = __webpack_public_path__ + "static/availability_3-dd059be69a4b569a980b8073dde72102.jpg";